import { useEffect, useState } from "react";

export const useHasHorizontalScroll = (ref: React.RefObject<HTMLElement>): boolean => {
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (ref.current) {
        setHasScroll(ref.current.scrollWidth > ref.current.clientWidth);
      }
    };

    checkScroll();

    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [ref]);

  return hasScroll;
};
